import axios from "axios";

export const getSiteList = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/info/project`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    return res.data;
  } catch (e) {
    console.log(e);
    return [];
  }
};
